"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = require("crm_data/meta/MetaProducers");

var getChildren = function getChildren(companyId) {
  var apiUrl = "companies/v2/families/" + companyId + "/children/with-total?limit=5";

  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(apiUrl);
  };

  return (0, _MetaAPI.queueFetch)(_MetaProducers.COMPANY_CHILDREN, fallback, {
    companyId: parseInt(companyId, 10)
  });
};

var addChild = function addChild(_ref) {
  var parentId = _ref.parentId,
      childId = _ref.childId;
  var apiUrl = "companies/v2/families/" + parentId + "/associations?childCompanyId=" + childId;
  return (0, _ImmutableAPI.put)(apiUrl);
};

var removeChild = function removeChild(_ref2) {
  var parentId = _ref2.parentId,
      childId = _ref2.childId;
  var apiUrl = "companies/v2/families/" + parentId + "/associations?childCompanyId=" + childId;
  return (0, _ImmutableAPI.del)(apiUrl);
};

var _default = {
  getChildren: getChildren,
  addChild: addChild,
  removeChild: removeChild
};
exports.default = _default;
module.exports = exports.default;